import request from '@/utils/request'

// 查询费用结果
export function calculateAgentPreOrderItemFee(params) {
  return request({
    url: `/agent_pre_orders/sim_card_calculate_fee`,
    method: 'get',
    params: params
  })
}

// 查询预制订单
export function findAgentPreOrders(params) {
  return request({
    url: `/agent_pre_orders`,
    method: 'get',
    params: params
  })
}

// 查询订单详情
export function findAgentPreOrder(id) {
  return request({
    url: `/agent_pre_orders/${id}`,
    method: 'get'
  })
}

// 查询订单状态
export function findAgentPreOrderStatusOptions() {
  return request({
    url: `/agent_pre_orders/status_options`,
    method: 'get'
  })
}

// 完成订单
export function finishAgentPreOrder(agentPreOrderId, data) {
  return request({
    url: `/agent_pre_orders/${agentPreOrderId}/finish`,
    method: 'post',
    data
  })
}
